import { methods, ServiceMaker } from "./index";

const { POST } = methods;

export const fetchAdd = (data) =>
  ServiceMaker(`/v1/api/report/add-plan`, POST, null, data);

export const fetchPayments = (data) =>
  ServiceMaker(`/v1/api/report/payment`, POST, null, data);

export const fetchEasyBuzzPayments = (data) =>
  ServiceMaker(`v1/api/report/EaseBuzzpayment`, POST, null, data);

export const fetchQuickpay = (data) =>
  ServiceMaker(`/v1/api/report/payment/quickpay`, POST, null, data);

export const fetchRenew = (data) =>
  ServiceMaker(`/v1/api/report/renew-plan`, POST, null, data);

export const fetchUsers = (data) =>
  ServiceMaker(`/v1/api/report/filteredUsers`, POST, null, data);

export const fetchServiceRequests = (data) =>
  ServiceMaker(`/v1/api/report/servicerequests`, POST, null, data);
